import { render, staticRenderFns } from "./FileUploadBase.vue?vue&type=template&id=014bd1fb&scoped=true&"
import script from "./FileUploadBase.vue?vue&type=script&lang=js&"
export * from "./FileUploadBase.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadBase.vue?vue&type=style&index=0&id=014bd1fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014bd1fb",
  null
  
)

export default component.exports